<template>
  <div class="row">
    <div class="col-12 male">
      <!-- <img class="d-block mx-auto" src="MFdefault.png" alt="default" v-if="is_male==false" width="100%" height="auto">
      <img class="d-block mx-auto" src="Male.png" alt="default" v-if="male=='male'" width="100%" height="auto">
      <img class="d-block mx-auto" src="Female.png" alt="default" v-if="male=='female'" width="100%" height="auto"> -->
      <span v-if="is_male==true && male=='male'" class='t'></span>
      <span v-else class='f'></span>
      <span class='inline-block'>male</span><br>
      <span v-if="is_male==true && male=='female'" class='t'></span>
      <span v-else class='f'></span>
      <span class='inline-block'>female</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Male',
  props: ["is_male", "male"]
}
</script>

<style>
.male{
  text-align: left;
  font-size: 1.2em;
  font-weight: bold;
}
.inline-block{
  margin-left: 0.5em;
}
.t{
    margin-left: 0.2em;
    display: inline-block;
    width: 0.7em;
    height: 0.7em;
    border-radius: 0.7em;
    background-color: #0000cd;
    color: #fff;
    text-align: center;
    line-height: 0.7em;
}
.f{
    margin-left: 0.2em;
    display: inline-block;
    width: 0.7em;
    height: 0.7em;
    border-radius: 0.7em;
    background-color: #fff;
    color: #fff;
    text-align: center;
    line-height: 0.7em;
}

</style>